import { Box } from "@mui/material";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import "./Suites.css";
import { SuitesNavbar } from "./Navbar/SuitesNavbar";
import { useAppSelector } from "../../store/hooks";
import { GetInspirationPopup } from "../InspirationLibrary/components/GetInspirationPopup";

export const Suites = () => {
  const [hideSidebar, setHideSidebar] = useState(false);
  const User = useAppSelector((s) => s.User);
  const handleHideSidebar = () => {
    setHideSidebar(!hideSidebar);
  };

  return (
    <Box className={`suites-view ${!User.IsAuthenticated ? "guest-view" : ""}`}>
      <Box className="suites-overview">
        <SuitesNavbar
          handleHideSidebar={handleHideSidebar}
          hideSidebar={hideSidebar}
        />
        <Box className={`suites-body`}>
          <Outlet />
        </Box>
      </Box>
      <GetInspirationPopup />
    </Box>
  );
};
